import request from '../utils/request'

const rentalHost = 'https://script.google.com/macros/s/AKfycbyqNwrLImrcWaQxE1WpVqy-ujuKHuBDHj5TNSDry1OuCKmxzrIK/exec'

export function getRentalsFromCalendar() {
  return request(rentalHost).getJson()
}
